import { render, staticRenderFns } from "./clone.vue?vue&type=template&id=88a8897a&"
import script from "./clone.vue?vue&type=script&lang=js&"
export * from "./clone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports